import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Eye, Library } from 'lucide-react';
import { AdaptiveModal } from '@/components/ui/AdaptiveModal';
import { Button } from '@/components/ui/button';
import { useHaptics } from '@/hooks/useHaptics';

interface RecipeSuccessDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  recipeTitle: string;
  recipeId: string;
  isEditing?: boolean;
}

const RecipeSuccessDialog: React.FC<RecipeSuccessDialogProps> = ({
  isOpen,
  onOpenChange,
  recipeTitle,
  recipeId,
  isEditing = false
}) => {
  const navigate = useNavigate();
  const { successNotification } = useHaptics();

  const handleViewRecipe = () => {
    successNotification();
    onOpenChange(false);
    navigate(`/recipe/${recipeId}`);
  };

  const handleBrowseRecipes = () => {
    onOpenChange(false);
    navigate('/recipe-collection');
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <AdaptiveModal
      isOpen={isOpen}
      onClose={handleClose}
      title={isEditing ? 'Recipe Updated!' : 'Recipe Created!'}
      position="center"
      size="sm"
    >
      <div className="flex items-center gap-3 mb-4">
        <CheckCircle className="h-6 w-6 text-green-600" />
        <h2 className="text-xl font-semibold">
          {isEditing ? 'Recipe Updated!' : 'Recipe Created!'}
        </h2>
      </div>
      <p className="text-muted-foreground mb-6 text-center">
        <span className="font-medium">"{recipeTitle}"</span> has been {isEditing ? 'updated' : 'saved'} successfully.
      </p>
      
      <div className="flex flex-col gap-3">
        <Button onClick={handleViewRecipe} className="w-full">
          <Eye className="mr-2 h-4 w-4" />
          View Recipe
        </Button>
        <Button variant="outline" onClick={handleBrowseRecipes} className="w-full">
          <Library className="mr-2 h-4 w-4" />
          Browse All Recipes
        </Button>
      </div>
    </AdaptiveModal>
  );
};

export default RecipeSuccessDialog;